<template>
  <div>
    <WsRead
      :modelName="modelName"
      :id="$route.params.id"
      :localeMode="localeMode"
      :label="label"
      :fields="fields"
      :primary="pageSetting.primary"
      :secondary="pageSetting.secondary"
      titleKey="name"
      :isMultiSelect="true"
      :filterSelects="filterSelects"
      :showExpand="false"
      :showFields="showFields"
      :deletable="false"
      @create-btn-click="$_onCreateBtnClick()"
      @tab-click="$_onTabClick($event)"
    >
    </WsRead>
    <WsMultiSelectDialog
      ref="multiSelectDialog"
      v-bind="_multiSelectDialogProps"
      :showExpand="false"
      isMultiSelect
      :showFields="showFields"
      @create-submit="$_onMultiSelectSubmit($event)"
    />
  </div>
</template>

<script>
import model from "@/models/organization";
import subModel from "@/models/factory";
export default {
  data: () => ({
    modelName: model.modelName,
    subModelName: subModel.modelName,
    label: model.label,
    localeMode: true,
    fields: model.fields,
    subFields: subModel.fields,
    showFields: ["name"],
    tabClickData: {},
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              fields: [
                "locales.name",
                "organization",
                "remark",
                "administrator_name",
                "administrator_email",
                "administrator_password_updated_at",
              ],
            },
          ],
        },
        {
          type: "tabs",
          tabItems: [
            {
              title: "子集團",
              value: "organization",
              count: "",
            },
            {
              title: "工廠",
              value: "factory",
              count: "",
            },
          ],
          tabSetting: [
            {
              type: "expandList",
              label: model.label,
              modelName: model.modelName,
              fields: model.fields,
              titleKey: "name",
              fieldsRead: ["name"],
              searchMode: false,
              orderBy: "updated_at",
              orderWay: "asc",
              hideOnNull: false,
              isVersionAPI: true,
              itemEditable: false,
              itemVersionReadable: false,
              expandDisable: true,
              itemVersionCreatable: false,
              itemLinkEditable: true,
              itemLinkCheckable: true,
              extendParams(data) {
                return {
                  organization: data.id,
                };
              },
            },
            {
              type: "expandList",
              label: subModel.label,
              modelName: subModel.modelName,
              fields: subModel.fields,
              titleKey: "name",
              fieldsRead: ["name"],
              searchMode: false,
              orderBy: "updated_at",
              orderWay: "asc",
              hideOnNull: false,
              isVersionAPI: true,
              itemEditable: false,
              itemVersionReadable: false,
              expandDisable: true,
              itemVersionCreatable: false,
              itemLinkEditable: true,
              itemLinkCheckable: true,
              extendParams(data) {
                return {
                  organization: data.id,
                };
              },
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              fields: ["industry_categories", "app"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_at", "created_admin"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_at", "updated_admin"],
            },
          ],
        },
        {
          type: "activeSwitch",
          title: "開通設定",
          remark: "關閉的集團將無法登入系統使用",
          field: "status",
        },
      ],
    },
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "篩選地區",
      },
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "organization",
        placeholder: "篩選所屬集團",
      },
    ],
  }),

  methods: {
    $_onCreateBtnClick() {
      this.$refs.multiSelectDialog.open();
    },
    $_onTabClick($event) {
      this.tabClickData = $event;
    },
    $_onMultiSelectSubmit($event) {
      const selectedId = $event.map((item) => item.id);
      if (this.tabClickData.value === "factory") {
        this.$axios.patch(`/${this.modelName}/${this.$route.param.id}`, {
          factory: selectedId,
        });
      } else {
        this.$axios.patch(`/${this.modelName}/${this.$route.param.id}`, {
          organization: selectedId,
        });
      }
    },
  },
  computed: {
    _multiSelectDialogProps() {
      if (this.tabClickData.value === "factory") {
        return {
          title: `新增工廠`,
          modelName: this.subModelName,
          fields: this.subFields,
        };
      } else {
        return {
          title: `新增子集團`,
          fields: this.fields,
          modelName: this.modelName,
        };
      }
    },
  },
};
</script>